import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ServiceIDType, ServiceIDResultType } from './types';

export interface ProfileState {
  service: ServiceIDType;
  result: ServiceIDResultType;
}

const initialState: ProfileState = {
  service: {
    id: undefined,
    args: undefined,
    extraOptions: undefined,
    api: undefined,
    hint: undefined
  },
  result: {
    data: undefined,
    status: undefined,
    url: undefined
  }
};

const profile = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setServiceIdData: (
      state: ProfileState,
      action: PayloadAction<ServiceIDType>
    ) => {
      state.service = action.payload;
    },
    setServiceIdResult: (
      state: ProfileState,
      action: PayloadAction<ServiceIDResultType>
    ) => {
      state.result = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setServiceIdData, setServiceIdResult } = profile.actions;

export default profile.reducer;
